import { render, staticRenderFns } from "./image-item.vue?vue&type=template&id=59145845"
import script from "./image-item.vue?vue&type=script&lang=ts"
export * from "./image-item.vue?vue&type=script&lang=ts"
import style0 from "./image-item.vue?vue&type=style&index=0&id=59145845&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports